import { Box, FormControl, SxProps } from '@mui/material';
import i18next from 'i18next';
import { LocalizationProvider, DatePicker as DP, DatePickerProps as DPProps } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import NotificationErrorIcon from '../Icons/NotificationErrorIcon';
import { FeedbackWrapper, InputLabelWrapper } from '../TextInput/TextInputStyle';
import ButtonField from './ButtonField';
import CalendarHeader from './CalendarHeader';
import dateCalendarStyles from './DateCalendarStyle';

export interface DateCalendarProps extends DPProps<DateTime> {
  error?: boolean;
  feedback?: JSX.Element | string;
  formStyle?: SxProps;
  triggerClear?: boolean;
  placeholder?: string;
  minDate?: DateTime;
  maxDate?: DateTime;
  disablePast?: boolean;
  disableFuture?: boolean;
}

function DateCalendar(props: DateCalendarProps) {
  const [open, setOpen] = useState(false);
  const { language } = i18next;
  const [componentKey, setComponentKey] = useState(Date.now());

  useEffect(() => {
    // forces the reset of the component when a reset filter is applied
    setComponentKey(Date.now());
  }, [props.triggerClear]);

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={language}>
      <FormControl sx={{ width: '100%', ...props.formStyle }}>
        {props.label ? <InputLabelWrapper shrink>{props.label}</InputLabelWrapper> : null}
        <DP
          key={componentKey}
          onError={props.onError}
          onChange={props.onChange}
          value={props.value}
          open={open}
          onClose={() => setOpen(false)}
          disablePast={props.disablePast}
          disableFuture={props.disableFuture}
          slots={{
            field: ButtonField,
            calendarHeader: CalendarHeader,
          }}
          minDate={props.minDate}
          maxDate={props.maxDate}
          slotProps={{
            field: {
              placeholder: props.placeholder ?? '    DD    |    MM    |    YYYY    ',
              error: props.error,
              onClick: () => setOpen((prev) => !prev),
            } as any,
            layout: {
              sx: dateCalendarStyles,
            },
          }}
          views={['day']}
        />
        {props.feedback ? (
          <FeedbackWrapper error={props.error} component="span">
            {props.error ? (
              <Box sx={{ paddingRight: '0.25rem', flexShrink: 0 }}>
                <NotificationErrorIcon />
              </Box>
            ) : null}
            {props.feedback}
          </FeedbackWrapper>
        ) : null}
      </FormControl>
    </LocalizationProvider>
  );
}

export default DateCalendar;
